module.exports = __webpack_public_path__ + "static/media/3h.94675e78.jpg";